import { Redirect, Route } from "react-router";

export const ProtectedRoute = (props:any) => {
    const hasToken = localStorage.getItem("token");
    
    return (
        hasToken ? <Route {...props}/> : <Redirect to="/login"/> 
    )
}